import { ColocaKpiCard } from "@/shared/components/data-display/ColocaKpiCard";
import useTranslations from "@/shared/lang/useTranslations";

import { LIST_KPI_FILTERS, type ListKpiFilterId } from "../../constants/payoutBatches.constants";
import { type PayoutBatchStats, PayoutBatchStatus } from "../../types/payoutBatches.types";

export interface BatchesKpiStripProps {
  stats: PayoutBatchStats | null;
  active: ListKpiFilterId;
  onChange: (id: ListKpiFilterId) => void;
}

const countFor = (
  stats: PayoutBatchStats | null,
  statuses: readonly PayoutBatchStatus[] | null,
): number | null => {
  if (!stats) return null;
  const keys = statuses ?? (Object.values(PayoutBatchStatus) as PayoutBatchStatus[]);
  return keys.reduce((sum, status) => sum + (stats[status] ?? 0), 0);
};

/** The strip IS the filter: each tile narrows the list to the statuses it counts. */
export function BatchesKpiStrip({ stats, active, onChange }: BatchesKpiStripProps) {
  const { t } = useTranslations("payoutBatches");
  return (
    <div className="grid grid-cols-2 gap-3 sm:grid-cols-4 xl:grid-cols-7">
      {LIST_KPI_FILTERS.map((filter) => {
        const count = countFor(stats, filter.statuses);
        return (
          <ColocaKpiCard
            key={filter.id}
            label={t(filter.labelKey)}
            value={count ?? "—"}
            accent={
              filter.id === "with_errors" && count
                ? "danger"
                : filter.id === "pending_approval" && count
                  ? "warning"
                  : "neutral"
            }
            selected={active === filter.id}
            onSelect={() => onChange(filter.id)}
          />
        );
      })}
    </div>
  );
}
